import React from 'react';
import styles from './ContactInformations.module.sass';
import Card from '../../../../components/Card';
import TextInput from '../../../../components/TextInput';
import PhoneInput from '../../../../components/PhoneInput';

const ContactInformations = ({ prospect, onProspectChange, onDropdownChange, loading }) => {
    return (
        <Card className={styles.card} title="Coordonnées" classTitle="title-green">
            <div className={styles.group}>
                <PhoneInput
                    className={styles.field}
                    label="Numéro de téléphone"
                    name="phone"
                    id="phone"
                    placeholder="+33 6 XX XX XX XX"
                    value={prospect?.phone || ''}
                    onChange={onProspectChange}
                    autoComplete="tel"
                />
                <TextInput
                    className={styles.field}
                    label="Email"
                    name="email"
                    type="email"
                    placeholder="email@example.com"
                    value={prospect?.email || ''}
                    onChange={onProspectChange}
                    required
                />
            </div>
        </Card>
    );
};

export default ContactInformations;